import { resetPasswordActions } from './actionTypes';
import { ResetPasswordState } from 'User/types/resetPassword';
import { Action } from 'shared/store/types';
import initialState from './constants/initialState';


const defaultState: ResetPasswordState = initialState;

const resetPassword = (state = defaultState, action: Action): ResetPasswordState => {
  const { type, payload } = action;

  switch (type) {
    case resetPasswordActions.SEND_OTP:
      return {
        ...state,
        password: payload.password,
        repeatPassword: payload.repeatPassword,
        mobileNumber: payload.mobileNumber,
        step: payload.step,
        sendOtpResponse: {
          message: payload.message,
          otpLength: payload.otpLength,
          otpStatus: payload.otpStatus,
          info: payload.info,
          retriesLeft: payload.retriesLeft,
        },
      };

    case resetPasswordActions.VERIFY_OTP:
      return {
        ...state,
        step: payload.step,
        verifyOtpResponse: {
          status: payload.status,
          error: {
            errorMessage: payload.message,
            info: payload.info,
            verifyAttemptsLeft: payload.verifyAttemptsLeft,
          },
        },
      };

    case resetPasswordActions.RESEND_OTP:
      return {
        ...state,
        step: payload.step,
        sendOtpResponse: {
          message: payload.message,
          otpLength: payload.otpLength,
          info: payload.info,
        },
      };

    case resetPasswordActions.VERIFY_OTP_FAIL:
      return {
        ...state,
        step: payload.step,
      };

    default:
      return state;
  }
};

export default resetPassword;
